import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import styles from './general.module.scss'
import Button from '../button'
import ApiContext from '../../utils/api-context'
import { formatAmountForDisplay } from '../../utils/stripe-helpers'
import { CurrencyContext } from '../../lib/context/CurrencyContext'
import { SettingsContext } from '../../lib/context/SettingsContext'

const ExperienceOfferCard = ({ gallery, small, experience }) => {
  const { apiUrl, cdnUrl } = useContext(ApiContext)
  const { currency } = useContext(CurrencyContext)
  const { settings } = useContext(SettingsContext)
  const [details, setDetails] = useState(null)
  useEffect(() => {
    if (experience.hasOwnProperty('id')) {
      fetch(`${apiUrl}/experiences/${experience.id}`).then((resp) => {
        resp.json().then((respJson) => {
          setDetails(respJson)
        })
      })
    }
  }, [experience])
  return (
    <>
      {details && (
        <div
          className={`${styles.card} ${styles.offer}
      ${gallery ? styles.gallery : ''}
      ${small ? styles.small : ''}`}
        >
          <div className={styles.favouriteTag}>
            From{' '}
            <span className={styles.favouritePrice}>
              {formatAmountForDisplay(
                experience.basePrice,
                currency,
                settings.exchangeRate
              )}{' '}
              {details.pricePer && <>/ {details.pricePer.text}</>}
              {(!details.pricePer || details.pricePer.perPerson) && (
                <>/ Person</>
              )}
            </span>
          </div>
          {!gallery && (
            <div className={styles.image}>
              <img
                src={`${
                  details.images[0].image !== null
                    ? details.images[0].image.url
                    : details.images[0].url
                }`}
                alt=""
              />
            </div>
          )}
          <div className={styles.inner}>
            <div className={styles.header}>
              <span className={styles.tagline}>{experience.cardTag}</span>
            </div>
            <h2 className="line-clamp-2" title={experience.name}>
              {experience.name}
            </h2>
            <p className={styles.clamp}>{experience.standfirst}</p>
            <div className={styles.footer}>
              <Button
                size="small"
                width="120px"
                color="green"
                href={`/experiences/${experience.slug}`}
                className={'cta-event-trigger'}
              >
                Explore
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
ExperienceOfferCard.propTypes = {
  gallery: PropTypes.bool,
  small: PropTypes.bool,
  experience: PropTypes.object.isRequired,
}
export default ExperienceOfferCard
